module.exports = __webpack_public_path__ + "static/media/tableappmain.60c1ec0e.png";